import axios from 'axios'

export async function getAllConvHistory(reqData: any) {
  const client = axios.create({ timeout: 10000 })
  const { apiEndPoint, agentId, startDate, endDate, searchKeyword, queueFilter, headers } = reqData
  return client.get(
    `${apiEndPoint}/api/conversation/v1/getConvHistoryByAgent?agentId=${agentId}&startDate=${startDate}&endDate=${endDate}&searchKeyword=${searchKeyword}&queueFilter=${queueFilter}`,
    {
      cancelToken: reqData.source.token,
      headers: headers
    }
  )
}

export async function getConversationId(reqData: any) {
  const client = axios.create({ timeout: 10000 })
  const { apiEndPoint, conversationId, queueFilter, headers } = reqData
  return client.get(
    `${apiEndPoint}/api/conversation/v1/getConvDetailsById/${conversationId}?queueFilter=${queueFilter}`,
    {
      cancelToken: reqData.source.token,
      headers: headers
    }
  )
}

export interface Conversation {
  contactId: string
  conversationID: string
  agentId: string
  customerId: string
  updateDate: string
  createDate: string
  conversationStartDate: string
  previousContactId: string
  nextContactId: string
  duration: number
  channel: string
  queue: string
  agentFirstName: string
  agentLastName: string
  csat: number
  customerFirstName: string
  customerLastName: string
  transferNote: string
  disconnectReason: string
  contactAttributes: string
  status: string
  response_time: number
}
